import * as React from 'react';
import { Box, Table, Typography, Sheet, IconButton, Chip, CircularProgress } from '@mui/joy';
import {CheckCircle, Close, Help, PhoneCallback, QuestionMark, QuestionMarkRounded} from '@mui/icons-material';
import Tooltip from "@mui/joy/Tooltip";
import ResponsiveTableWrapper from "../ui/ResponsiveTableWrapper";

// --- Interface (no change needed) ---
interface LeadRow {
    id: number;
    customer_id: number;
    created_at: string;
    customer_name: string;
    converted: boolean;
    services: string;
    speedToLead: number | null;
}

// --- Helper Functions (no change needed) ---
function formatDate(isoString: string): string {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    return date.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

function formatSecondsToHMS(seconds: number | null): string {
    // This function will now only be called with non-null values
    if (seconds === null || seconds < 0) return 'N/A';
    if (seconds < 1) return 'Instant';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return [
        h > 0 ? `${h}h` : '',
        m > 0 ? `${m}m` : '',
        s > 0 ? `${s}s` : '',
    ].filter(Boolean).join(' ').trim();
}

// --- The Main Table Component (Updated) ---
export default function AttemptedLeadsTable({ leads, isLoading }: { leads: LeadRow[], isLoading: boolean }) {


    if (isLoading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
    }

    if (!leads || leads.length === 0) {
        return (
            <Typography sx={{ p: 2, textAlign: 'center' }}>
                No attempted leads found for this period.
            </Typography>
        );
    }

    return (
        <ResponsiveTableWrapper minWidth={700}>
            <Table hoverRow aria-label="table of attempted leads">
                <thead>
                <tr>
                    <th>Customer Name</th>
                    <th style={{width: '25%'}}>Services</th>
                    <th>Speed to Lead</th>
                    <th>Status</th>
                    <th>Lead Created</th>
                </tr>
                </thead>
                <tbody>
                {leads.map((lead) => (
                    <tr key={lead.id}>
                        <td><Typography fontWeight="md">{lead.customer_name}</Typography></td>
                        <td>{lead.services}</td>
                        <td>
                            {/* --- THIS IS THE KEY CHANGE --- */}
                            {lead.speedToLead !== null ? (
                                formatSecondsToHMS(lead.speedToLead)
                            ) : (
                                <Typography sx={{display: 'flex', alignItems: 'center'}}level="body-xs" color="neutral">
                                    N/A
                                    <Tooltip
                                        title={"You created this lead"}
                                        arrow
                                        color="danger"
                                        placement="top"
                                        size="sm"
                                        variant="soft"
                                    >
                                        <Help sx={{ml: 1, fontSize: '22px'}}/>

                                    </Tooltip>

                                </Typography>
                            )}
                        </td>
                        <td>
                            {lead.converted ? (
                                <Chip variant="soft" color="success" size="sm" startDecorator={<CheckCircle />}>Converted</Chip>
                            ) : (
                                <Chip variant="soft" color="danger" size="sm" startDecorator={<Close />}>Not Converted</Chip>
                            )}
                        </td>
                        <td>{formatDate(lead.created_at)}</td>

                    </tr>
                ))}
                </tbody>
            </Table>
        </ResponsiveTableWrapper>
    );
}